import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { 
  PanelGroup, Panel, Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import { each, reduce, filter, find, map } from 'lodash';
import Fa from 'react-fontawesome';
import ordinal from 'ordinal-js';
import moment from 'moment-timezone';

import NumberDisplay from '../../../../components/number-display';

import ProgressBar from '../../../../components/progress-bar';

import { winLossFetchCollectorSummary, requestShowSurveyEmail } from '../../DashboardActions';
import { getCurrentCollectorSummary } from '../../DashboardReducer';


class CollectorStepSummary extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      loaded: false,
      errors: null,
      activeKey: null,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.cancel = this.cancel.bind(this);
    this.showContactNextEmail = this.showContactNextEmail.bind(this);
  }

  componentWillMount() {
    // const { collector } = this.props;
    // do loading here
    this.load();
  }


  showContactNextEmail(step, contact) {
    const {
      collector, object, isAccount,
    } = this.props;
    const date = contact.next_email_date;
    const subject = contact.next_scheduled_subject || contact.email_subject;
    const message = contact.next_scheduled_message || contact.email_message;
    this.props.dispatch(requestShowSurveyEmail({
      step_id: step.id,
      subject,
      message,
      date,
      email: contact.email,
      name: `${contact.first_name} ${contact.last_name}`,
      status: contact.last_status,
      contact_id: contact.id,
      collector_id: collector.collector_id,
      opportunity_id: object.opportunity_id,
      is_manual: step.is_manual,
      time_zone: collector.time_zone,
      is_account: isAccount,
      account_id: object.account_id,
      isNext: true,
      scheduleOnly: true,
      step_name: step.step_name,

      email_from: contact.email_from,

      program_id: collector.program_id,
      client_id: collector.client_id,
      collector_email: collector.from_email,
      collector_name: collector.collector_name,
    }));
  }

  cancel() {
    this.setState({ showingModal: false });
  }
  load() {
    const {
      collector, object, isAccount,
    } = this.props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    this.setState({
      loading: true, loaded: false, errors: null, activeKey: null,
    }, () => {
      this.props.dispatch(winLossFetchCollectorSummary(collector.collector_id, id, isAccount))
        .then(
          () => {
            const { steps } = this.props;
            let activeKey = null;
            if (steps && steps.length > 0) {
              if (steps[0].is_waiting_room) {
                activeKey = 'waiting';
              } else {
                activeKey = steps[0].id;
              }
            }
            this.setState({
              loaded: true,
              loading: false,
              activeKey,
            });
          },
          (errors) => {
            this.setState({ errors, loaded: false, loading: false });
          },
        );
    });
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  renderTime(localTime, foreignTime, id) {
    const format = 'MMM DD, YYYY \\a\\t hh:mm A';
    let localSuffix = null;
    const localStr = localTime.date.format(format);
    let foreignTimeStr = null;

    if (foreignTime !== null) {
      foreignTimeStr = foreignTime.date.format(format);
    }
    if (foreignTimeStr && foreignTimeStr !== localStr) {
      localSuffix = ' (local time)';
    }
    const comp = (<span>{localStr}{localSuffix}</span>);
    if (foreignTime !== null && foreignTimeStr !== localStr) {
      const popover = (
        <Tooltip id={id}>
          <div>
            or {foreignTimeStr} ({foreignTime.utc})
          </div>
        </Tooltip>
      );
      return (
        <OverlayTrigger key={id} trigger={['hover', 'focus']} placement="top" overlay={popover}>
          <span style={{ cursor: 'pointer', background: 'lightyellow' }}>
            {comp}
          </span>
        </OverlayTrigger>
      );
    }
    return comp;
  }


  renderErrors() {
    return null; // for now
  }

  renderContacts(step, isFirstStep = false) {
    const { contacts } = step;
    const isManual = step.is_manual;
    const isWating = step.is_waiting_room === true;
    const stepId = step.id;
    if (!contacts || contacts.length <= 0) {
      return <div>No contacts found.</div>;
    }
    return (
      <ul>
        {contacts.map((contact) => {
          // const isCustom = contact.next_scheduled_subject !== null || contact.next_scheduled_message !== null;
          let suffix = 'manually';
          const ifNeeded = isFirstStep ? ' ' : ', if needed, ';
          if (!isManual) {
            const { localTime, foreignTime } = contact;
            suffix = (<span>on {this.renderTime(localTime, foreignTime, `${stepId}|${contact.id}`)}</span>);
          }
          const thisEmail = (
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showContactNextEmail(step, contact);
              }}
            >
              this email
            </a>
          );
          const contactName = (<strong>{contact.first_name} {contact.last_name}</strong>);

          return (
            <li key={contact.id}>
              {isWating && contactName}
              {!isWating &&
                <div>
                  {contactName}
                  {' '}
                  will receive
                  {' '}
                  {thisEmail}
                  {ifNeeded}
                  {' '}
                  {suffix}.
                </div>
              }
            </li>
          )
        })}
      </ul>
    );
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderSteps() {
    const { steps, survey } = this.props;
    const { activeKey } = this.state;
    const filtered = survey && survey.id;
    return (
      <div>
        {!filtered && <h4>Email Outreach Plan</h4>}
        <PanelGroup
          id="step-summary"
          activeKey={activeKey}
          onSelect={this.handleSelect}
          accordion
        >
          {steps.map((step, idx) => {
            const { id } = step;
            const isActive = activeKey === id;
            const isWaitingRoom = step.is_waiting_room === true;
            const panelKey = isWaitingRoom ? 'waiting' : id;
            let stepOrder = null;
            if (!filtered && step.order && !isWaitingRoom) {
              stepOrder = (<span>{step.order}:&nbsp;</span>);
            }
            return (
              <Panel
                key={panelKey}
                eventKey={panelKey}
              >
                <Panel.Heading>
                  <Panel.Title>
                    <Panel.Toggle componentClass="div">
                      <table>
                        <tbody>
                          <tr>
                            <td width="99%" className="text-active" style={{ cursor: 'pointer' }}>
                              <span style={{ color: '#222' }}>
                                {stepOrder}{step.step_name}{!filtered && ': '}{!filtered && <NumberDisplay precision={0} value={step.contacts.length} suffix="contact" suffixIsUnit />}
                              </span>
                            </td>
                            <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </Panel.Toggle>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <div>{this.renderContacts(step, idx === 0)}</div>
                </Panel.Body>
              </Panel>
            );
          })}
        </PanelGroup>
      </div>
    );
  }

  render() {
    const { loading, loaded, errors } = this.state;
    if (loading) {
      return (<ProgressBar />);
    }
    if (!loaded && errors) {
      return this.renderErrors();
    }
    if (loaded) {
      return this.renderSteps();
    }
    return null;
  }
}


CollectorStepSummary.propTypes = {
  dispatch: PropTypes.func.isRequired,
  object: PropTypes.shape({
    account_id: PropTypes.string,
    opportunity_id: PropTypes.string,
  }),
  isAccount: PropTypes.bool,
  collector: PropTypes.shape({
    collector_id: PropTypes.string,
    time_zone: PropTypes.shape({}),
    email_from: PropTypes.shape({}),
  }),
  survey: PropTypes.shape({
    contact_id: PropTypes.string,
  }),
  steps: PropTypes.arrayOf(PropTypes.shape({})),
};
CollectorStepSummary.defaultProps = {
  object: null,
  isAccount: false,
  collector: null,
  survey: null,
  steps: [],
};

// Retrieve data from store as props

function getTimes(date, collector) {
  let foreignTime = null;
  const localTime = {
    date: moment(date),
  };
  if (collector.time_zone !== null && collector.time_zone !== undefined && collector.time_zone.utc !== null) {
    localTime.date = moment(date).tz(collector.time_zone.utc);
    foreignTime = {
      date: moment(date),
      utc: collector.time_zone.utc,
    };
  }
  return {
    localTime,
    foreignTime,
  };
}

function cleanUpData(steps, collector) {
  if (steps) {
    const hasWaitingRoom = find(steps, { is_waiting_room: true }) !== undefined;

    each(steps, (step, i) => {
      const o = hasWaitingRoom ? i : (i + 1);
      step.order = `${o}${ordinal.ordinalSuffix(o)} Step`;
      if (!step.is_manual) {
        each(step.contacts, (contact) => {
          const { localTime, foreignTime } = getTimes(contact.next_email_date, collector);
          contact.localTime = localTime;
          contact.foreignTime = foreignTime;
        });
      }
    });
  }
  return steps;
}

function mapStateToProps(state, ownProps) {
  const rawSteps = getCurrentCollectorSummary(state);
  let steps = rawSteps;
  const { survey, collector } = ownProps;
  if (survey && survey.contact_id) {
    steps = reduce(rawSteps, (items, step) => {
      const contacts = filter(step.contacts, { contact_id: survey.contact_id });
      if (contacts.length > 0) {
        items.push({
          ...step,
          contacts: map(contacts, (contact) => {
            return {
              email_from: collector ? collector.email_from : null,
              ...contact,
            };
          }),
        });
      }
      return items;
    }, []);
  }
  return {
    steps: cleanUpData(steps, ownProps.collector),
  };
}

export default connect(mapStateToProps)(CollectorStepSummary);
